export const enum HttpMethodEnum {
  Get = 'Get',
  Post = 'Post',
  Put = 'Put',
  Delete = 'Delete'
}

export const enum HttpResponseTypeEnum {
  Empty = 'Empty',
  Json = 'Json',
  Text = 'Text',
  Xml = 'Xml',
}

export type RecordValue = {
  key: string
  value: string
}

export type HttpRequest = {
  url: string,
  method: HttpMethodEnum
  body?: string,
  headers?: Record<string, string>
  form?: Record<string, string> | null
  response_type?: HttpResponseTypeEnum
}
